var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0.00341797 133.095H177.149V0.00439453H0.00341797V133.095Z",
          fill: "#80CF40",
        },
      }),
      _c("path", {
        attrs: {
          d: "M177.146 133.11C177.146 96.3583 137.49 66.5645 88.573 66.5645C39.6553 66.5645 0 96.358 0 133.11H177.146Z",
          fill: "#40A810",
        },
      }),
      _c("path", {
        attrs: {
          d: "M0 0C0 36.752 39.6553 66.5459 88.573 66.5459C137.49 66.5459 177.146 36.7523 177.146 0.000266212L0 0Z",
          fill: "#40A810",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }